var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "44",
        "height": "44",
        "viewBox": "0 0 88 88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "-29.875%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColotBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "fill": "url(#a)",
        "cx": "44",
        "cy": "44",
        "r": "44"
      }
    }), _c('path', {
      attrs: {
        "d": "M30 28h32v32H30z"
      }
    }), _c('path', {
      attrs: {
        "d": "M56.228 32.028H35.772c-2.084.003-3.769 1.66-3.772 3.703v14.44c.003 2.045 1.688 3.7 3.772 3.704h11.447l1.175-3.169c-.025-.028-.044-.056-.069-.084a7.038 7.038 0 01-.419-.55 5.914 5.914 0 01-.39-.64c-.038-.07-.082-.138-.116-.207a6.954 6.954 0 01-.263-.606c-.028-.075-.05-.153-.078-.232a5.945 5.945 0 01-.193-.7 8.542 8.542 0 01-.088-.478c-.01-.075-.025-.15-.031-.228-.438-3.715 2.278-7.075 6.062-7.503a6.98 6.98 0 011.77.025 7.014 7.014 0 011.072.225l.037.01c.287.09.571.196.843.321.06.025.116.053.172.082.263.125.516.265.76.421l.015.01c.256.169.503.356.734.556.032.028.063.056.097.084a6.907 6.907 0 011.241 1.463c.169.262.316.537.444.822V35.73c.006-2.044-1.681-3.7-3.766-3.703zM44.41 48.816h-8.24a.842.842 0 01-.838-.85.843.843 0 01.838-.822h8.24c.472.01.847.387.838.85a.84.84 0 01-.838.822zm0-5.291h-8.24a.84.84 0 01-.838-.85.84.84 0 01.838-.822h8.24a.84.84 0 01.838.85.845.845 0 01-.838.822zm4.128-5.297H36.17a.84.84 0 01-.838-.85.843.843 0 01.838-.822H48.54a.84.84 0 01.837.85.843.843 0 01-.84.822zm5.116 2.831c-2.925-.003-5.3 2.325-5.303 5.197-.003 2.872 2.369 5.203 5.294 5.203 2.925.004 5.3-2.325 5.303-5.196v-.004c-.003-2.868-2.372-5.193-5.294-5.2zm0 7.67c-1.39 0-2.516-1.104-2.519-2.47 0-1.362 1.125-2.468 2.516-2.471 1.39 0 2.516 1.103 2.519 2.468v.003c-.003 1.366-1.128 2.47-2.516 2.47zm-2.6 8.18l-.681-1.04a.837.837 0 00-.94-.338l-1.204.369 1.49-4.022a6.97 6.97 0 002.791 1.103l-1.456 3.928zm6.819-1.375a.829.829 0 00-.94.338l-.682 1.037-1.456-3.928c1-.162 1.953-.54 2.79-1.106l1.491 4.022-1.203-.363z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};